import React from "react";
export const ThumbsUp = () => (
  <svg viewBox="0 0 15 16">
    <path d="M8.13 1.83l-3.69 3.7c-.25.24-.39.58-.39.94v6.66c0 .73.6 1.33 1.33 1.33h6c.53 0 1.01-.32 1.23-.81l2.17-5.07c.56-1.32-.41-2.79-1.84-2.79H9.18l.63-3.05a.996.996 0 00-1.68-.91zM1.39 14.46c.73 0 1.33-.6 1.33-1.33V7.79c0-.73-.6-1.33-1.33-1.33S.06 7.06.06 7.79v5.33c-.01.74.59 1.34 1.33 1.34z" />
  </svg>
);
